class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      this.handleProgressiveBar()
      const cartDrawerItems = this.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        // cartDrawerItems.updateCartUpsellToggleState();
        // cartDrawerItems.updateCartUpsellVisibility();

        // cartDrawerItems.updateCartUpsellToggleState2();
        // cartDrawerItems.updateCartUpsellVisibility2();
      }

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    
  }

  handleProgressiveBar() {
  // Use setTimeout to delay your style change to ensure it happens after all other updates
  setTimeout(() => {
    const scrittaBarra = document.getElementById('scritta-barra-progressiva');
    const barLength = document.getElementById('shipping-gradient');
    
    if (!scrittaBarra || !barLength) return; // Add safety check
    
    const totalGet = parseInt(document.querySelector('.totals__total-value').getAttribute('cart-total-value-custom')) / 100;
    const spesaMinima = barLength.getAttribute('min-spent');
    
    let spentPerc = (totalGet / parseInt(spesaMinima)) * 100 <= 100 ? (totalGet / parseInt(spesaMinima)) * 100 : 100;
    
    if(spentPerc === 100) {
      scrittaBarra.innerHTML = `Hai sbloccato la spedizione <b>GRATIS</b>`;
    }
    
    // Use setAttribute instead of direct style manipulation
    barLength.setAttribute('style', `width: ${spentPerc}%`);
    
    // Also store the calculated width value as a data attribute
    barLength.dataset.calculatedWidth = `${spentPerc}%`;
    
    // Create a MutationObserver to ensure the style stays applied
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style') {
          const currentWidth = barLength.style.width;
          const savedWidth = barLength.dataset.calculatedWidth;
          
          if (currentWidth !== savedWidth) {
            barLength.style.width = savedWidth;
          }
        }
      });
    });
    
    // Start observing
    observer.observe(barLength, { attributes: true });
    
    // Disconnect after a reasonable time (5 seconds)
    setTimeout(() => observer.disconnect(), 5000);
  }, 250); // Small delay to let other scripts run first
}
  

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
